import React from 'react';
import { useNavigate } from 'react-router-dom';
import { tourPackageData } from '../../../data/tourPackageData';
import Icon from '../../../components/AppIcon';


const TourPackages = () => {
  const navigate = useNavigate();

  const getAllTourPackages = () => {
    const packages = [];
    const packageKeys = Object.keys(tourPackageData);
    
    packageKeys?.forEach(key => {
      const pkg = tourPackageData?.[key];
      if (pkg?.from && pkg?.to && pkg?.vehicles?.length > 0) {
        const startingPrice = Math.min(...pkg?.vehicles?.map(v => v?.price));
        packages?.push({
          id: key,
          from: pkg?.from,
          to: pkg?.to,
          destination: `${pkg?.from} To ${pkg?.to}`,
          price: `₹ ${startingPrice}/-`,
          image: pkg?.vehicles?.[0]?.image || "https://images.unsplash.com/photo-1684703155964-295375d953a4",
          alt: pkg?.vehicles?.[0]?.alt || `${pkg?.from} to ${pkg?.to} tour package`
        });
      }
    });
    
    return packages?.slice(0, 12);
  };

  const tourPackages = getAllTourPackages();

  const handlePackageClick = (pkg) => {
    navigate(`/tour-package-booking/${pkg?.cityName}/${pkg?.destination}`);
    window.scrollTo(0, 0);
  };

  return (
    <section className="py-16 bg-gradient-to-br from-green-50 via-white to-blue-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12 animate-fade-in-down">
          <h2 className="text-3xl md:text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-green-600 via-blue-600 to-green-600 mb-4">
            Tour Packages
          </h2>
          <p className="text-gray-600 text-lg">
            Explore amazing destinations with our curated tour packages
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {tourPackages?.slice(0, 8)?.map((pkg, index) => (
            <div
              key={index}
              onClick={() => handlePackageClick(pkg)}
              className="group bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 cursor-pointer hover-lift border-2 border-transparent hover:border-green-400 animate-fade-in-up"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="relative h-48 overflow-hidden image-zoom">
                <img
                  src={pkg?.image}
                  alt={pkg?.alt}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent"></div>
                <div className="absolute top-3 right-3 bg-green-500 text-white px-3 py-1 rounded-full text-sm font-bold animate-pulse">
                  {pkg?.duration}
                </div>
                <div className="absolute bottom-3 left-3 right-3">
                  <h3 className="text-white font-bold text-lg mb-1 transition-transform duration-300 group-hover:translate-x-2">
                    {pkg?.destination}
                  </h3>
                  <p className="text-blue-200 text-sm transition-transform duration-300 group-hover:translate-x-2">
                    From {pkg?.cityName}
                  </p>
                </div>
              </div>
              <div className="p-4">
                <p className="text-gray-600 text-sm mb-3 line-clamp-2">{pkg?.description}</p>
                <button className="w-full py-2.5 bg-gradient-to-r from-green-500 to-blue-500 hover:from-green-600 hover:to-blue-600 text-white font-bold rounded-lg transition-all duration-300 btn-hover transform hover:scale-105">
                  View Package
                </button>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-10 animate-fade-in">
          <button
            onClick={() => {
              navigate('/tour-packages');
              window.scrollTo(0, 0);
            }}
            className="inline-flex items-center gap-2 px-8 py-4 bg-gradient-to-r from-green-600 to-blue-600 hover:from-green-700 hover:to-blue-700 text-white font-bold rounded-full transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-105 btn-hover"
          >
            <span>View All Packages</span>
            <Icon name="ArrowRight" size={20} />
          </button>
        </div>
      </div>
    </section>
  );
};

export default TourPackages;